(() => {
  if (window.menminColorSwatches) return;
  window.menminColorSwatches = true;

  const cardImages = (swatch) => {
    const card = swatch.closest('[data-product-block]');
    return card ? card.querySelectorAll('[data-product-image] img') : [];
  };

  const preview = (swatch) => {
    const src = swatch.dataset.image;
    if (!src) return;
    cardImages(swatch).forEach((img) => {
      if (!img.hasAttribute('data-mcs-src')) {
        img.setAttribute('data-mcs-src', img.getAttribute('src') || '');
        img.setAttribute('data-mcs-srcset', img.getAttribute('srcset') || '');
      }
      img.removeAttribute('srcset');
      img.src = src;
    });
  };

  const restore = (swatch) => {
    cardImages(swatch).forEach((img) => {
      if (!img.hasAttribute('data-mcs-src')) return;
      img.src = img.getAttribute('data-mcs-src');
      const srcset = img.getAttribute('data-mcs-srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      img.removeAttribute('data-mcs-src');
      img.removeAttribute('data-mcs-srcset');
    });
  };

  // mouseenter/mouseleave don't bubble, so the tooltip span inside the swatch
  // can't retrigger them; capture phase lets one document listener see them all.
  const on = (type, handler) =>
    document.addEventListener(type, (e) => {
      const el = e.target;
      if (el instanceof Element && el.matches('.mcs--card .mcs__swatch')) handler(el);
    }, true);

  on('mouseenter', preview);
  on('mouseleave', restore);
  on('focusin', preview);
  on('focusout', restore);
})();
